module.exports = __webpack_public_path__ + "img/article-1612327170.e6122163.jpg";